module.exports = __webpack_public_path__ + "images/logout-icon-10986d0c.svg";